import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UniversalWaitingRoom from '../components/UniversalWaitingRoom';
import O2OLiveRoom from '../components/O2OLiveRoom';

/**
 * Phase 38A.4 · Route /session/:sessionId/waiting-room
 *
 * Orchestrates the two phases of a private realtime session:
 *   1. Waiting Room (countdown + presence)  → default view
 *   2. Live Room (LiveKit)                  → mounted after successful join
 */
const WaitingRoomPage = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [joinBundle, setJoinBundle] = useState(null);

  const handleJoin = (bundle) => {
    // For O2O we mount the live room; for public Lives the join endpoint
    // returns a token that the LiveDetailPage flow will consume.
    if (bundle?.session_type === 'oto') {
      setJoinBundle(bundle);
      return;
    }
    // Fallback: navigate to the Live detail using the returned room_name
    // (which is the Nymia live id).
    if (bundle?.room_name) {
      navigate(`/lives/${bundle.room_name}`);
    }
  };

  const handleExit = () => {
    setJoinBundle(null);
    navigate('/');
  };

  if (joinBundle && joinBundle.session_type === 'oto') {
    return (
      <O2OLiveRoom
        joinBundle={joinBundle}
        sessionId={sessionId}
        mode={joinBundle.mode || (joinBundle.livekit_role === 'audio' ? 'audio' : 'video')}
        onExit={handleExit}
      />
    );
  }

  return (
    <UniversalWaitingRoom
      sessionId={sessionId}
      currentUserId={user?.id}
      onJoin={handleJoin}
      onLeave={() => navigate(-1)}
    />
  );
};

export default WaitingRoomPage;
